(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ebarrito-card-swatches"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ebarrito-card-swatches')) {
    customElements.define('ebarrito-card-swatches', class extends HTMLElement {
      connectedCallback() {
        if (!this.initialized) {
          this.initialized = true;
          this.addEventListener('click', (event) => {
            const more = event.target.closest('.ebarrito-swatches__more');
            if (more && this.contains(more)) {
              this.toggleAttribute('data-expanded');
              this.updateLayout();
              return;
            }
            const swatch = event.target.closest('a[data-color]');
            if (!swatch || !this.contains(swatch) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
            event.preventDefault();
            this.select(swatch);
          });
          this.addEventListener('keydown', (event) => {
            if (event.key === ' ' && event.target.matches('a[data-color]')) {
              event.preventDefault();
              this.select(event.target);
            }
          });
          this.preloadedImages = new Map();
          this.onIntent = (event) => {
            const swatch = event.target.closest('a[data-color]');
            if (swatch && this.contains(swatch)) this.preload(swatch, 'auto');
          };
          this.addEventListener('pointerover', this.onIntent);
          this.addEventListener('focusin', this.onIntent);
          this.addEventListener('pointerdown', this.onIntent, { passive: true });
          this.leaveCard = () => this.closest('.card-wrapper')?.classList.remove('ebarrito-color-preview');
          this.leaveSwatches = () => {
            this.leaveCard();
            const secondImage = this.closest('.card-wrapper')?.querySelector('.card__media .media > img + img');
            if (secondImage) {
              secondImage.loading = 'eager';
              secondImage.fetchPriority = 'auto';
            }
          };
          this.addEventListener('pointerleave', this.leaveSwatches);
          this.warmVisible = () => {
            if (!this.isConnected || !this.inView || !this.canPreload()) return;
            const visible = Array.from(this.querySelectorAll('a[data-color]')).filter((item) =>
              item.dataset.current !== 'true' &&
              (this.hasAttribute('data-expanded') || !item.classList.contains('ebarrito-swatches__extra'))
            );
            visible.slice(0, 3).forEach((item) => this.preload(item));
          };
          this.scheduleWarm = () => {
            clearTimeout(this.warmTimer);
            if (document.readyState !== 'complete') return;
            this.warmTimer = setTimeout(this.warmVisible, 180);
          };
          this.resize = () => this.updateLayout();
        }
        this.updateLayout();
        this.closest('.card-wrapper')?.addEventListener('pointerleave', this.leaveCard);
        if (window.matchMedia?.('(hover: hover) and (pointer: fine)').matches && this.canPreload()) {
          if ('IntersectionObserver' in window) {
            this.visibilityObserver ||= new IntersectionObserver((entries) => {
              this.inView = entries.some((entry) => entry.isIntersecting);
              if (this.inView) this.scheduleWarm();
              else clearTimeout(this.warmTimer);
            }, { threshold: 0.1 });
            this.visibilityObserver.observe(this.closest('.card-wrapper') || this);
          }
          window.addEventListener('load', this.scheduleWarm, { once: true });
        }
        if ('ResizeObserver' in window) {
          this.observer ||= new ResizeObserver(this.resize);
          this.observer.observe(this);
        } else {
          window.addEventListener('resize', this.resize);
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.visibilityObserver?.disconnect();
        clearTimeout(this.warmTimer);
        window.removeEventListener('load', this.scheduleWarm);
        this.closest('.card-wrapper')?.removeEventListener('pointerleave', this.leaveCard);
        window.removeEventListener('resize', this.resize);
      }

      canPreload() {
        const connection = navigator.connection;
        return !connection?.saveData && !/^(slow-)?2g$/.test(connection?.effectiveType || '');
      }

      preload(swatch, priority = 'low') {
        if (!this.canPreload() || !swatch.dataset.image) return;
        const mainImage = this.closest('.card-wrapper')?.querySelector('.card__media img');
        if (!mainImage) return;
        const sizes = mainImage.sizes || `${mainImage.clientWidth || 360}px`;
        const key = swatch.dataset.imageSrcset + '|' + sizes;
        const existing = this.preloadedImages.get(key);
        if (existing) {
          if (priority === 'auto') existing.fetchPriority = 'auto';
          return;
        }
        const image = new Image();
        image.loading = 'eager';
        image.decoding = 'async';
        image.fetchPriority = priority;
        image.sizes = sizes;
        image.onload = () => image.decode?.().catch(() => {});
        image.onerror = () => this.preloadedImages.delete(key);
        this.preloadedImages.set(key, image);
        image.srcset = swatch.dataset.imageSrcset || '';
        image.src = swatch.dataset.image;
      }

      select(swatch) {
        const card = this.closest('.card-wrapper');
        if (!card) return;
        card.classList.add('ebarrito-color-preview');
        this.querySelectorAll('a[data-color]').forEach((item) => {
          item.setAttribute('aria-pressed', String(item === swatch));
          item.dataset.current = String(item === swatch);
        });
        this.querySelector('.ebarrito-swatches__selection').textContent =
          swatch.dataset.color + (swatch.dataset.available === 'false' ? ' — ' + swatch.dataset.badge : '');
        card.querySelectorAll('.card__heading a, .quick-add-modal a.full-unstyled-link, [data-ebarrito-variant-link]').forEach((link) => {
          link.href = swatch.href;
        });
        card.querySelectorAll('[data-ebarrito-color-title]').forEach((title) => {
          title.textContent = (title.dataset.prefix ?? ' — ') + swatch.dataset.color;
        });
        card.querySelectorAll('[data-product-url]').forEach((button) => {
          button.dataset.productUrl = swatch.getAttribute('href');
        });
        const images = card.querySelectorAll('.card__media .media > img');
        if (images[0] && swatch.dataset.image) {
          images[0].loading = 'eager';
          images[0].fetchPriority = 'high';
          images[0].decoding = 'async';
          images[0].dataset.ebarritoFit = swatch.dataset.imageFit;
          images[0].srcset = swatch.dataset.imageSrcset;
          images[0].src = swatch.dataset.image;
          images[0].alt = swatch.dataset.imageAlt;
          if (images[1]) {
            images[1].loading = 'eager';
            images[1].fetchPriority = 'low';
            images[1].dataset.ebarritoFit = swatch.dataset.secondFit;
            images[1].srcset = swatch.dataset.secondSrcset;
            images[1].src = swatch.dataset.secondImage;
            images[1].alt = swatch.dataset.imageAlt;
          }
        }
        const price = card.querySelector('.card-information > .price');
        const newPrice = swatch.querySelector('template[data-color-price]')?.content.firstElementChild;
        if (price && newPrice) price.replaceWith(newPrice.cloneNode(true));
        this.updateLayout();
        card.querySelectorAll('.card__badge').forEach((holder, index) => {
          const oldBadge = holder.querySelector('.badge');
          const badge = document.createElement('span');
          badge.id = oldBadge?.id || (card.querySelector('.card__heading a')?.id + '-color-badge-' + index);
          badge.className = 'badge badge--bottom-left ' +
            (swatch.dataset.badgeType === 'sold-out' ? this.dataset.soldOutClass : this.dataset.saleClass);
          badge.textContent = swatch.dataset.badge;
          badge.hidden = !swatch.dataset.badge;
          holder.replaceChildren(badge);
        });
      }

      updateLayout() {
        const swatches = Array.from(this.querySelectorAll('a[data-color]'));
        const more = this.querySelector('.ebarrito-swatches__more');
        const configuredMaximum = Number(this.dataset.maxVisible) || 4;
        const width = this.clientWidth;
        const capacity = width > 0 ? Math.max(1, Math.floor(width / 44)) : configuredMaximum + 1;
        const needsMore = swatches.length > Math.min(configuredMaximum, capacity);
        const maximum = needsMore ? Math.max(1, Math.min(configuredMaximum, capacity - 1)) : swatches.length;
        const selectedIndex = swatches.findIndex((swatch) => swatch.dataset.current === 'true');
        const limit = selectedIndex >= maximum ? maximum - 1 : maximum;
        swatches.forEach((swatch, index) => swatch.classList.toggle('ebarrito-swatches__extra', index >= limit && index !== selectedIndex));
        this.dataset.ready = 'true';
        if (!more) return;
        const expanded = this.hasAttribute('data-expanded');
        more.hidden = !needsMore;
        more.setAttribute('aria-expanded', String(expanded));
        more.setAttribute('aria-label', expanded ? more.dataset.collapseLabel : more.dataset.expandLabel);
        more.textContent = expanded ? '−' : '+' + (swatches.length - maximum);
        if (this.inView) this.scheduleWarm();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ebarrito-catalog-layout"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ebarrito-catalog-layout')) {
    customElements.define('ebarrito-catalog-layout', class extends HTMLElement {
      static balance(cards) {
        const groups = new Map();
        for (const card of cards) {
          if (card.dataset.ebarritoBag !== 'true') continue;
          const id = card.dataset.ebarritoProduct;
          if (!groups.has(id)) groups.set(id, []);
          groups.get(id).push(card);
        }
        const buckets = Array.from(groups.values());
        const orderedBags = [];
        const rounds = Math.max(0, ...buckets.map((items) => items.length));
        for (let round = 0; round < rounds; round++) {
          for (const items of buckets) if (items[round]) orderedBags.push(items[round]);
        }
        let bagIndex = 0;
        return cards.map((card) => card.dataset.ebarritoBag === 'true' ? orderedBags[bagIndex++] : card);
      }

      connectedCallback() {
        if (this.dataset.done || this.dataset.enabled !== 'true' || this.dataset.allowMix === 'false') return;
        if (this.dataset.sort && this.dataset.sort !== 'manual') return;
        const grid = this.previousElementSibling;
        if (!grid?.matches('ul.product-grid')) return;
        this.dataset.done = 'true';
        const ordered = this.constructor.balance(Array.from(grid.children));
        ordered.forEach((card, index) => {
          if (grid.children[index] !== card) grid.insertBefore(card, grid.children[index] || null);
          if (card.hasAttribute('data-cascade')) card.style.setProperty('--animation-order', String(Math.min(index + 1, 6)));
          if (index < 4) card.querySelector('.card__media img')?.setAttribute('loading', 'eager');
        });
        grid.dataset.ebarritoMixed = 'true';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ebarrito-category-load-more"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ebarrito-category-load-more')) {
    customElements.define('ebarrito-category-load-more', class extends HTMLElement {
      connectedCallback() {
        if (!this.initialized) {
          this.grid = this.closest('[data-ebarrito-category]')?.querySelector('[data-category-grid]');
          this.button = this.querySelector('button');
          this.status = this.querySelector('[role="status"]');
          if (!this.grid || !this.button || !this.status) return;
          this.initialized = true;
          this.media = matchMedia('(min-width: 990px)');
          this.revealed = Math.min(this.batchSize, this.grid.children.length);
          this.pending = [];
          this.seen = new Set(Array.from(this.grid.children, (card) => card.dataset.ebarritoKey || card.dataset.ebarritoProduct));
          this.baseUrl = new URL(this.dataset.url, location.href);
          this.nextUrl = this.dataset.remoteMore === 'true' ? this.baseUrl.href : null;
          this.onResize = () => {
            this.revealed = Math.min(this.grid.children.length, this.expanded ? Math.max(this.revealed, this.batchSize) : this.batchSize);
            this.refresh();
          };
          this.button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.loadNext();
          });
        }
        this.media.addEventListener('change', this.onResize);
        this.refresh();
      }

      disconnectedCallback() {
        this.request?.abort();
        this.media?.removeEventListener('change', this.onResize);
      }

      get batchSize() {
        return Number(this.media.matches ? this.dataset.desktopLimit : this.dataset.mobileLimit) || 6;
      }

      refresh() {
        Array.from(this.grid.children).forEach((card, index) => { card.hidden = index >= this.revealed; });
        this.grid.setAttribute('data-category-ready', '');
        const more = this.revealed < this.grid.children.length || this.pending.length > 0 || this.nextUrl;
        this.button.hidden = !more;
        this.hidden = !more && !this.expanded;
        return Boolean(more);
      }

      prepareCard(card) {
        // The same model can appear in several categories. Scope every card ID
        // and its references to this grid, including quick-add and badge labels.
        const ids = new Map();
        [card, ...card.querySelectorAll('[id]')].forEach((element) => {
          if (!element.id) return;
          const oldId = element.id;
          element.id = this.grid.id + '-' + oldId;
          ids.set(oldId, element.id);
        });
        [card, ...card.querySelectorAll('*')].forEach((element) => {
          ['aria-labelledby', 'aria-describedby', 'aria-controls', 'for', 'form', 'list'].forEach((attribute) => {
            const value = element.getAttribute(attribute);
            if (value) element.setAttribute(attribute, value.split(/\s+/).map((id) => ids.get(id) || id).join(' '));
          });
          ['href', 'data-modal', 'data-target'].forEach((attribute) => {
            const value = element.getAttribute(attribute);
            if (value?.startsWith('#') && ids.has(value.slice(1))) element.setAttribute(attribute, '#' + ids.get(value.slice(1)));
          });
        });
        card.querySelectorAll('script, link[rel="stylesheet"]').forEach((element) => element.remove());
        card.querySelectorAll('img').forEach((image) => image.setAttribute('loading', 'lazy'));
        [card, ...card.querySelectorAll('.scroll-trigger')].forEach((element) => {
          element.classList.add('scroll-trigger--cancel');
          element.classList.remove('scroll-trigger--offscreen');
        });
        return document.importNode(card, true);
      }

      async fetchPage(request) {
        const url = new URL(this.nextUrl, location.href);
        if (url.origin !== location.origin || url.pathname !== this.baseUrl.pathname) throw new Error('Invalid category URL');
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('sort_by', this.dataset.sort || 'manual');
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const timeout = setTimeout(() => request.abort(), 20000);
        try {
          const response = await fetch(url.href, { signal: request.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Unable to load category');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const collection = doc.querySelector('collection-component');
          const container = collection?.querySelector('#ProductGridContainer');
          const grid = container?.querySelector('ul[data-ebarrito-grid]');
          const loader = container?.querySelector('ebarrito-load-more');
          if (collection?.dataset.collectionId !== this.dataset.collectionId || !container) throw new Error('Wrong category response');
          if (!grid) {
            if (!container.querySelector('.collection--empty')) throw new Error('Missing category grid');
            this.nextUrl = null;
            return;
          }
          if (!loader || loader.dataset.sectionId !== this.dataset.sectionId) throw new Error('Wrong section response');
          const nextLink = loader.querySelector('.ebarrito-load-more__link');
          let nextUrl = null;
          if (nextLink) {
            nextUrl = new URL(nextLink.getAttribute('href'), url);
            const page = Number(nextUrl.searchParams.get('page'));
            const currentPage = Number(url.searchParams.get('page') || 1);
            if (nextUrl.origin !== location.origin || nextUrl.pathname !== this.baseUrl.pathname || !Number.isInteger(page) || page <= currentPage) throw new Error('Invalid next category page');
          }
          for (const card of Array.from(grid.children)) {
            const key = card.dataset.ebarritoKey || card.dataset.ebarritoProduct;
            if (card.tagName !== 'LI' || !key || this.seen.has(key)) continue;
            this.pending.push(this.prepareCard(card));
            this.seen.add(key);
          }
          this.nextUrl = nextUrl?.href || null;
        } finally {
          clearTimeout(timeout);
        }
      }

      async loadNext() {
        if (this.loading || this.button.hidden) return;
        const currentLocation = location.pathname + location.search;
        const request = new AbortController();
        this.request = request;
        this.loading = true;
        this.button.disabled = true;
        this.grid.setAttribute('aria-busy', 'true');
        this.status.textContent = this.dataset.loading;
        try {
          const batch = this.batchSize;
          while (this.grid.children.length - this.revealed + this.pending.length < batch && this.nextUrl) {
            await this.fetchPage(request);
            if (!this.isConnected || currentLocation !== location.pathname + location.search) return;
          }
          const firstNew = this.revealed;
          const needed = Math.max(0, batch - (this.grid.children.length - this.revealed));
          const scrollPosition = window.scrollY;
          this.grid.append(...this.pending.splice(0, needed));
          this.revealed = Math.min(this.grid.children.length, this.revealed + batch);
          this.expanded = true;
          this.status.textContent = this.refresh() ? this.dataset.loaded : this.dataset.complete;
          const firstCard = this.grid.children[firstNew];
          const focusTarget = Array.from(firstCard?.querySelectorAll('.card__heading a') || []).find((link) => link.getClientRects().length);
          focusTarget?.focus({ preventScroll: true });
          window.scrollTo({ top: scrollPosition, behavior: 'instant' });
        } catch (_) {
          if (this.isConnected && currentLocation === location.pathname + location.search) this.status.textContent = this.dataset.error;
        } finally {
          this.loading = false;
          this.button.disabled = false;
          this.grid.removeAttribute('aria-busy');
          if (this.request === request) this.request = null;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ebarrito-load-more"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ebarrito-load-more')) {
    customElements.define('ebarrito-load-more', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('click', (event) => {
          const link = event.target.closest('.ebarrito-load-more__link');
          if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
          event.preventDefault();
          this.loadNext(link);
        });
        queueMicrotask(() => {
          if (!this.isConnected) return;
          this.updateCount();
          const grid = this.closest('#ProductGridContainer')?.querySelector('ul[data-ebarrito-grid]');
          if (!grid || grid.children.length) return;
          this.hidden = false;
          const link = this.querySelector('.ebarrito-load-more__link');
          if (link) this.loadNext(link, true);
          else this.querySelector('[role="status"]').textContent = this.dataset.empty;
        });
      }

      updateCount() {
        if (!location.pathname.includes('/collections/')) return;
        const section = this.closest('.shopify-section');
        const grid = this.closest('#ProductGridContainer')?.querySelector('ul[data-ebarrito-grid]');
        if (!section || !grid || !this.dataset.visibleCount) return;
        const models = new Set(Array.from(grid.children, (card) => card.dataset.ebarritoProduct).filter(Boolean));
        section.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach((count) => {
          count.textContent = this.dataset.visibleCount.replace('[count]', String(models.size)).replace('[cards]', String(grid.children.length));
        });
      }

      disconnectedCallback() {
        this.request?.abort();
      }

      async loadNext(link, automatic = false) {
        const container = this.closest('#ProductGridContainer');
        const grid = container?.querySelector('ul[data-ebarrito-grid]');
        if (this.loading || !grid || link.hidden || container.querySelector('.collection.loading')) return;
        const status = this.querySelector('[role="status"]');
        const currentLocation = location.pathname + location.search;
        let url = new URL(link.href, location.href);
        if (url.origin !== location.origin || url.pathname !== location.pathname) return;
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        const request = new AbortController();
        this.request = request;
        this.loading = true;
        this.hidden = false;
        link.setAttribute('aria-disabled', 'true');
        grid.setAttribute('aria-busy', 'true');
        status.textContent = this.dataset.loading;
        const cardKey = (card) => card.dataset.ebarritoKey || card.querySelector('a[href]')?.getAttribute('href');
        const seen = new Set(Array.from(grid.children, cardKey).filter(Boolean));
        let timeout;
        try {
          // Empty batches can contain only sold-out bags. Follow the server's next
          // page until visible cards are found, without losing shoes or new models.
          while (url) {
            if (preview) url.searchParams.set('preview_theme_id', preview);
            url.searchParams.set('section_id', this.dataset.sectionId);
            timeout = setTimeout(() => request.abort(), 20000);
            const response = await fetch(url.href, { signal: request.signal, credentials: 'same-origin' });
            if (!response.ok) throw new Error('Unable to load catalog');
            const html = await response.text();
            clearTimeout(timeout);
            if (!this.isConnected || currentLocation !== location.pathname + location.search || container.querySelector('.collection.loading')) return;
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const sourceContainer = doc.getElementById('ProductGridContainer');
            const sourceGrid = sourceContainer?.querySelector('ul[data-ebarrito-grid]');
            const nextLoader = sourceContainer?.querySelector('ebarrito-load-more');
            if (!sourceGrid || !nextLoader || nextLoader.dataset.sectionId !== this.dataset.sectionId) throw new Error('Invalid catalog response');
            const nextLink = nextLoader.querySelector('.ebarrito-load-more__link');
            let nextUrl;
            if (nextLink) {
              nextUrl = new URL(nextLink.getAttribute('href'), url);
              nextUrl.searchParams.delete('section_id');
              const nextPage = Number(nextUrl.searchParams.get('page'));
              const currentPage = Number(url.searchParams.get('page'));
              if (nextUrl.origin !== location.origin || nextUrl.pathname !== location.pathname || !Number.isInteger(nextPage) || nextPage <= currentPage) throw new Error('Invalid next catalog page');
              if (preview) nextUrl.searchParams.set('preview_theme_id', preview);
            }
            const appended = [];
            for (const card of Array.from(sourceGrid.children)) {
              if (card.tagName !== 'LI') continue;
              const key = cardKey(card);
              if (key && seen.has(key)) continue;
              if (key) seen.add(key);
              card.querySelectorAll('img').forEach((image) => image.setAttribute('loading', 'lazy'));
              [card, ...card.querySelectorAll('.scroll-trigger')].forEach((element) => {
                element.classList.add('scroll-trigger--cancel');
                element.classList.remove('scroll-trigger--offscreen');
              });
              appended.push(document.importNode(card, true));
            }
            const layout = container.querySelector('ebarrito-catalog-layout');
            const Layout = customElements.get('ebarrito-catalog-layout');
            if (Layout?.balance && layout?.dataset.enabled === 'true' && layout.dataset.allowMix !== 'false' && (!layout.dataset.sort || layout.dataset.sort === 'manual')) {
              appended.splice(0, appended.length, ...Layout.balance(appended));
            }
            const scrollPosition = window.scrollY;
            grid.append(...appended);
            if (nextUrl) link.href = nextUrl.href;
            else link.hidden = true;
            this.updateCount();
            if (appended.length || !nextUrl) {
              status.textContent = grid.children.length ? (nextUrl ? this.dataset.loaded : this.dataset.complete) : this.dataset.empty;
              if (!automatic) {
                appended[0]?.querySelector('.card__heading a, a[href]')?.focus({ preventScroll: true });
                window.scrollTo({ top: scrollPosition, behavior: 'instant' });
              }
              break;
            }
            url = nextUrl;
          }
        } catch (_) {
          if (this.isConnected && currentLocation === location.pathname + location.search) status.textContent = this.dataset.error;
        } finally {
          clearTimeout(timeout);
          this.loading = false;
          link.removeAttribute('aria-disabled');
          grid.removeAttribute('aria-busy');
          if (this.request === request) this.request = null;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
